import { useQuery } from "@apollo/client";
import { AppContext } from "AppContainer";
import wabobaLogo from "assets/waboba-logo.png";
import queryString from "query-string";
import { useContext, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ConfirmResetPasswordForm from "./ConfirmResetPasswordForm";
import { FETCH_RANDOM_IMAGE } from "./graphql";
import LoginForm from "./LoginForm";
import ResetPasswordForm from "./ResetPasswordForm";

const AuthPages = () => {
  const { data } = useQuery(FETCH_RANDOM_IMAGE);
  const { user } = useContext(AppContext);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      let redirectTo = queryString.parse(location.search).redirectTo || "/me";
      navigate(redirectTo);
    }
  }, [user, location.search, navigate]);

  return (
    <div
      className="flex items-center justify-center bg-center bg-cover h-screen"
      style={
        data && data.randomPromoImage
          ? {
              backgroundImage: `url(${
                process.env.NODE_ENV === "development"
                  ? "https://cdn.waboba.com/assets/promo_images/a79cdf555e194db9a8dbbfe5dd6bc64e-Jeff_Nass_Productions_WingmanPro_Web_Res-66.jpg"
                  : data.randomPromoImage.url
              })`,
              // backgroundImage: `url(${data.randomPromoImage.url})`,
            }
          : null
      }
    >
      <div className="p-12 md:rounded-[2.75rem] [corner-shape:squircle] backdrop-blur-2xl backdrop-saturate-150 bg-white/55 dark:bg-gray-900/45 border border-white/60 dark:border-white/10 shadow-[inset_0_1px_0_rgba(255,255,255,0.6),0_20px_60px_-20px_rgba(0,0,0,0.35)] dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_20px_60px_-20px_rgba(0,0,0,0.6)] h-full flex flex-col items-center justify-center md:h-auto w-full md:max-w-lg py-14 px-16">
        <div className="w-full">
          <div className="flex justify-center">
            <img className="h-16" src={wabobaLogo} alt="Waboba" />
          </div>

          <h2 className="text-center mt-4">Waboba ID</h2>

          {/* <div className="text-center mt-2 font-light">Waboba ID</div> */}

          <Routes>
            <Route>
              <Route index element={<LoginForm />} />
              <Route path="reset-password" element={<ResetPasswordForm />} />
              <Route
                path="reset-password/:code/:key"
                element={<ConfirmResetPasswordForm />}
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          </Routes>

          <div className="opacity-60 text-xs mt-8 space-x-8 text-center">
            <span>
              Copyright © {new Date().getFullYear()} Waboba AB. All rights
              reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPages;
